import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HelpFastInputDialogComponent } from './help-fast-input-dialog/help-fast-input-dialog.component';

@Component({
  selector: 'app-help-fast-input',
  templateUrl: './help-fast-input.component.html',
  styleUrls: ['./help-fast-input.component.scss'],
  standalone: false,
})
export class HelpFastInputComponent {
  constructor(public dialog: MatDialog) {}

  open(): void {
    this.dialog.open(HelpFastInputDialogComponent);
  }
}
